import { useCallback, useEffect, useState } from 'react';

const isTypingInInput = () => {
  const { activeElement } = document;
  if (!activeElement) return false;

  const { tagName } = activeElement;
  return tagName === 'INPUT' || tagName === 'TEXTAREA' || activeElement.isContentEditable;
};

const isKPressWithCmdOrCtrl = (event) => {
  if (!event) return false;

  const key = String(event.key || '').toLowerCase();
  const isCmdOrCtrlPressed = event.metaKey || event.ctrlKey;

  return isCmdOrCtrlPressed && key === 'k';
};

export default ({ defaultOpen = false } = {}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((previousIsOpen) => !previousIsOpen), []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isKPressWithCmdOrCtrl(event)) return;
      if (isTypingInInput()) return;

      event.preventDefault();
      toggle();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggle]);

  return {
    isOpen,
    open,
    close,
    toggle,
  };
};
